<template>
  <div class="banner_container">
    <div class="banner-login-table" v-show="!isLogin">
      <div class="banner-login-title">用户登录</div>
      <div class="login-user-table">
        <input type="text" v-model="username" class="login-user-inp login-user-bgimg" placeholder="请输入手机号">
      </div>
      <div class="login-password-table">
        <input type="password" v-model="password" class="login-password-inp" placeholder="请输入密码">
      </div>
      <div class="login-btn">
        <a href="javascript:;" @click="toLogin">登录</a>
      </div>
      <router-link to="/ForGetPassword" class="wjpassword">忘记密码</router-link>
    </div>
    <el-carousel
      :interval="5000"
      height="360px"
      arrow="never"
    >
      <el-carousel-item v-for="item in bannerList" :key="item.id">
        <img class="bannerPic" @click="bannerClick(item)" :src="item.picture" alt="">
      </el-carousel-item>
    </el-carousel>

  </div>
</template>

<script>
import '../../../assets/css/index.css'
import {ApiGetBanner, ApiLogin} from '../../../net/home/index.js'
import {hex_sha1} from '../../../assets/js/hmac-sha1.js'
import {phoneFun, checkMobile, setCookie, getCookie, removeCookie} from '../../../untils/common.js'
import store from '../../../vuex/store.js'
export default {
  data: function () {
    return {
      bannerList: [],
      username: '', // 手机号
      password: '',
    }
  },
  store,
  computed: {
    isLogin: function () {
      return this.$store.state.isLogin
    }
  },
  methods:{
    getBanner: function () {
      ApiGetBanner({'platform': 'pc'}).then(res=>{

        if (res.code == 200) {
          this.bannerList = res.value.map(item=>{
            return {...item, picture: item.pcPicture}
          })
        }
      })
    },
    checkLogin: function () {
      if (!phoneFun(this.username)) {
        this.$message({
          message: '手机号码格式有误',
          type: 'warning'
        })
        return false
      }

      if (!checkMobile(this.password)) {
        this.$message({
          message: '密码格式有误',
          type: 'warning'
        })
        return false
      }

      return true
    },
    toLogin: function () {
      if (!this.checkLogin()) {return}
      const prames = {
        username: this.username,
        password: hex_sha1(`${this.password}sinograin`)
      }
      ApiLogin(prames).then(res=>{
       // console.log('res', res)
        if (res.code == 200) {
          setCookie('user', JSON.stringify(res.value))
          setCookie('token', res.value.token)
          this.$store.commit('toLogin', true)
          this.username = ''
          this.password = ''
          this.$message({
            message: '登录成功',
            type: 'success'
          })
          if (!res.value.label) {
            this.$store.commit('changeShowLabels', true)
          }
        } else {
          // this.$message.error(`登录失败`)
          // this.password = ''
        }
      })
    },
    todetail: function (id){
      if(!this.$store.state.isLogin){
        this.$store.commit('showLogin', true)
        return
      }
      this.$router.push({
          path : 'CourseDetail',
          query : {id : id},
      })
    },
    toPlandetail: function (id){
      if(!this.$store.state.isLogin){
        this.$store.commit('showLogin', true)
        return
      }
      this.$router.push({
          path : 'PlanDetail',
          query : {id : id},
      })
    },
    bannerClick: function (item) {
       // console.log('item', item)
       switch(item.type){
         case 1: //1外链
            window.open(item.url)
            break;
         case 2: //2课程
            this.todetail(item.detailId)
            break;
         case 3: //3消息
            this.$router.push('/News/'+ item.id)
            break;
         case 4: // 4专项练习分类
            break;
         case 5: //5任务
            this.toPlandetail(item.detailId)
            break;
         case 7: //7 党史竞赛
            if(!this.$store.state.isLogin){
              this.$store.commit('showLogin', true)
              return
            }
            this.$store.commit('changeCdjsID', item.detailId)
            this.$emit('openCDJS')
            break;
         default:
            //其他

       }
    }
  },
  mounted: function () {
    this.getBanner()
  }
}
</script>

<style scoped>
.bannerPic{
  width: 100%;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/children/banner.vue